export const iconFontAwesomeCodingCircleNodes = (
	<i className="fa-solid fa-circle-nodes"></i>
);
